var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56011 11C8.56917 11 11.0625 8.51037 11.0625 5.5C11.0625 2.48962 8.56438 0 5.55532 0C2.54889 0 0.0625 2.48962 0.0625 5.5C0.0625 8.51037 2.55368 11 5.56011 11ZM5.56011 10.19C2.96545 10.19 0.879593 8.10058 0.879593 5.5C0.879593 2.89942 2.96066 0.810019 5.55532 0.810019C8.15477 0.810019 10.248 2.89942 10.248 5.5C10.248 8.10058 8.15956 10.19 5.56011 10.19ZM4.59949 8.52427H6.81943C7.01766 8.52427 7.17374 8.38033 7.17374 8.17939C7.17374 7.99017 7.01766 7.8393 6.81943 7.8393H6.09036V4.92606C6.09036 4.66977 5.95821 4.49973 5.71689 4.49973H4.67778C4.47956 4.49973 4.32826 4.65062 4.32826 4.83719C4.32826 5.03597 4.47956 5.18207 4.67778 5.18207H5.32858V7.8393H4.59949C4.39912 7.8393 4.24518 7.99017 4.24518 8.17939C4.24518 8.38033 4.39912 8.52427 4.59949 8.52427ZM5.52179 3.54669C5.88589 3.54669 6.17433 3.25978 6.17433 2.89553C6.17433 2.53127 5.88589 2.24271 5.52179 2.24271C5.16249 2.24271 4.86926 2.53127 4.86926 2.89553C4.86926 3.25978 5.16249 3.54669 5.52179 3.54669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.f1749d07bc76227ad10df45b02d4d0ac.svg";
export { ForwardRef as ReactComponent };